import { Effect } from "../../Materials/effect";
var name = 'morphTargetsVertexDeclaration';
var shader = "#ifdef MORPHTARGETS\nattribute vec3 position{X};\n#ifdef MORPHTARGETS_NORMAL\nattribute vec3 normal{X};\n#endif\n#ifdef MORPHTARGETS_TANGENT\nattribute vec3 tangent{X};\n#endif\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */

export var morphTargetsVertexDeclaration = {
  name: name,
  shader: shader
};